export const MEDGEMMA_WAKEUP = {
  cooldownMs: 60_000,
  text: "hello again medgamma",
  url: "/chatbot/api-proxy.php",
};

export const MEDGEMMA_STORAGE_PREFIX = "medgemma_";
export const MAX_LOCAL_CHAT_HISTORY = 20;
export const SUGGESTION_PANEL_GAP = 6;
export const CONSULTATION_TIME_ZONE = "Africa/Algiers";
export const SERVER_NAIVE_DATES_ARE_UTC = true;

export const PAYMENT_PRICE_KEYS = {
  strict: [
    "price",
    "prix",
    "tarif",
    "cost",
    "unit_price",
    "unitPrice",
    "pu",
    "price_cents",
    "priceCents",
  ],
  secondary: ["montant"],
  ambiguous: ["amount", "value"],
};

export const CURRENCY_HINT_PATTERN = /(da|dzd|dz|dinar|دج|د\.?ج|€|eur|usd|\$)/i;
export const CANCELLED_DEBT_PATTERN = /Dette\s+annul[ée]e?.*?:\s*([0-9]+(?:[.,][0-9]{1,2})?)/i;
export const ANNULMENT_SERVICE = "__ANNULATION__";
export const DEBT_IMPUTATION_SERVICE = "__IMPUTATION_DETTE__";
